/*
 * @description:
 * @author: wolfgun
 * @Date: 2020-12-10 09:43:49
 */
import { toPairs } from 'ramda'
const getters = {
  title: state => state.settings.title,
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  nickname: state => state.user.username,
  roles: state => state.user.roles,
  permission_routes: state => state.permission.routes,
  userDetailBaseInfo: state => state.user.userinfo.info,
  avatarUrl: state => $imgUrl+state.user.userinfo.info.avatar,
  userDetailPairs: state => {
    const baseInfo = state.user.userinfo.info
    if (baseInfo) {
      delete baseInfo.avatar
      delete baseInfo.id
      baseInfo.lastLoginTerminal = baseInfo.lastLoginTerminal === 1 ? 'IOS' : '安卓'
      const result = toPairs(baseInfo)
      return result
    }
  },
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  userDetailQuestionList: state => state.user.userinfo.questionList,
  userDetailCountries: state => state.user.userinfo.countries?.split(','),
  userDetailCities: state => state.user.userinfo.cities?.split(','),
  userDetailPayType: state => [state.user.userinfo.payType],
  authVideoDetail: state => state.user.videoDetail
}
export default getters
